import { useEffect, useRef } from "react";

export default function Ticker() {
  const tickerRowRef = useRef(null);
  const contents = [
    "Breakout Sessions",
    "Live Music",
    "Roundtables",
    "Networking",
    "Leading-Edge Data",
    "Expert Speakers",
    "Networking Mixer",
    "Post Conference Workshop",
  ];

  useEffect(() => {
    if (tickerRowRef.current) {
      const contentsTwice = [...contents, ...contents];
      tickerRowRef.current.innerHTML = "";

      contentsTwice.forEach((content, index) => {
        const span = document.createElement("span");
        span.textContent = content;
        tickerRowRef.current.appendChild(span);

        const starIcon = document.createElement("i");
        starIcon.className = "fa-solid fa-star-christmas";
        tickerRowRef.current.appendChild(starIcon);
      });
    }
  });

  return (
    <section
      className="ticker"
      style={{ backgroundImage: `url(/img/bg-sunny-gradient3.webp)` }}
    >
      <div className="ticker-row" ref={tickerRowRef}></div>
    </section>
  );
}
